import React, {useState} from 'react';
import { useTranslation } from "react-i18next";

import OutputType from "./OutputType";

const Block = (props) => {
    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const {subaccount,subaccountIndex,checkOutputType,addRemoveField,isDefault,saveData,savingStatus,onInputChange } = props;
    const {t, i18n} = useTranslation();
    //console.log('[Block.js] received props',props);

    const outputsSharedProps = {
        subaccount: subaccount,
        subaccountIndex: subaccountIndex,
        checkboxHandler: checkOutputType,
        fieldHandler : addRemoveField,
        onInputChange : onInputChange,
        isDefault: isDefault
    }

    return (
        <form className="notification-management__block" key={'managementblock-'+subaccountIndex}>
            <div className="row">
                <div className="col-md-3">
                    {
                        (!isDefault) &&
                        <h3 className="notification-management__block__title">
                            <strong>{subaccount.infos.subAccountName}</strong><br/>
                            {subaccount.infos.subAccountCode}
                        </h3>
                    }
                </div>
                <div className="col-md-4">
                    <OutputType type="email" {...outputsSharedProps} validate={setEmailError} />
                </div>
                <div className="col-md-5 mt-3 mt-md-0">
                    <div className="row">
						{ /*
						<div className="col-md-6">
							<OutputType type="phone" {...outputsSharedProps} validate={setPhoneError} />
						</div>
						*/ }
                        <div className="col-md-6">
                            <OutputType type="sms" {...outputsSharedProps} validate={setPhoneError}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-end">
                <div className="col-md-5">
                    {
                        (!subaccount.untouched) &&
                        <button disabled={emailError || phoneError}
                            className="btn btn--raised btn--raised--red btn--small"
                                type="submit"
                                onClick={e => {
                                e.preventDefault();
                                saveData(isDefault);
                            }}>
                            { (savingStatus !== true)
                                ?
                                (<React.Fragment>
                                    <span className="btn__text">{t('profile.notifications.buttons.save')}</span>
                                    <span className="btn__icon btn__arrow arrow arrow--right">
                                        <i className="fas fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </React.Fragment>) :
                                (<i className="fas fa-circle-notch fa-spin"></i>)
                            }

                        </button>
                    }
                </div>
            </div>
        </form>
    );
};

export default Block;
